import { Pressable, SxProp, useDripsyTheme, View } from 'dripsy';
import React from 'react';
import { GestureResponderEvent } from 'react-native';
import { Icon, SVGIconList } from '../icons/Icon';

import { TextTitle } from '../typography';

export interface UniTabHeaderProps {
  title: string;
  icon?: SVGIconList;
  onBack: (event: GestureResponderEvent) => void;
  suffixButtonGroups?: Array<React.ReactElement>;
  showBackButton?: boolean;
  sx?: SxProp;
  labelColor?: string;
}

export const UniTabHeader: React.FC<UniTabHeaderProps> = ({
  title,
  icon,
  onBack,
  suffixButtonGroups,
  showBackButton = true,
  sx,
  labelColor
}) => {
  const { theme } = useDripsyTheme();
  let textColor = theme.colors?.$black as string;
  if (labelColor && theme.colors?.[labelColor]) {
    textColor = theme.colors?.[labelColor] as string;
  }
  return (
    <View sx={{ ...tabHeaderSxStyles.container, ...sx }}>
      <View sx={tabHeaderSxStyles.left}>
        {showBackButton && (
          <Pressable onPress={onBack}>
            <View>
              <Icon name="arrowLeft" themeColor={textColor} color={textColor} />
            </View>
          </Pressable>
        )}
      </View>
      <View sx={tabHeaderSxStyles.title}>
        {icon && (
          <View sx={tabHeaderSxStyles.iconWrapper}>
            <Icon name={icon} themeColor={textColor} />
          </View>
        )}
        <TextTitle semiBold sx={{ color: textColor }}>
          {title}
        </TextTitle>
      </View>

      {suffixButtonGroups && <View sx={tabHeaderSxStyles.right}>{suffixButtonGroups}</View>}
    </View>
  );
};

const tabHeaderSxStyles: Record<string, SxProp> = {
  container: {
    paddingY: '$3',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: '$backgroundPrimary'
  },
  left: {
    position: 'absolute',
    left: '$4',
    height: '$7',
    width: '$7',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100
  },
  title: {
    flex: 3,
    left: 5,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: '$2',
    lineHeight: '$2'
  },
  right: {
    position: 'absolute',
    right: 0,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  button: {
    marginX: '$1'
  },
  iconWrapper: {
    mr: '$2'
  }
};
